module.exports = __webpack_public_path__ + "2490f4bdc9f6ba4a049e56bbe00dfc9e.svg";